export const getCreateSingleSeriesPayload = (values) => {
    return {
        title: values.title,
        postsType: 'video',
        description: values.description || '',
        coverImageResourceId: values.coverImageResourceId,
        thumbnailResourceId: values.thumbnailImageResourceId,
    };
};
